import Collapse from 'bootstrap/js/dist/collapse';
import ScrollSpy from 'bootstrap/js/dist/scrollspy';
import StickyObserver from 'sticky-observer';
import Tab from 'bootstrap/js/dist/tab';
import domLoaded from 'dom-loaded';

domLoaded.then(() => {
  // Keep track of what section is scrolled to in the sticky navbar.
  const navbarEl = document.getElementById('school-bus-navbar');
  new ScrollSpy(document.body, {
    target: navbarEl,
  });

  // Only show the title part of the sticky navbar once the navbar is "stuck"
  // to the top (since it's duplicative of the hero image header).
  const navbarBrandEl = navbarEl.querySelector('.navbar-brand');
  new StickyObserver(navbarEl, (stuck) => {
    navbarBrandEl.hidden = !stuck;
  });

  // Handle the custom buttons that need to link to a separate tab and an
  // accordion button inside that tab.
  document.querySelectorAll('[data-link-toggle=tab-accordion]').forEach((linkEl) => {
    const tabTarget = linkEl.dataset.tabTarget;
    const tabTriggerEl = document.querySelector(`[data-bs-toggle=pill][data-bs-target="${tabTarget}"]`);
    const tab = new Tab(tabTriggerEl);

    const accordionTarget = linkEl.dataset.accordionTarget;
    const accordionCollapseEl = document.querySelector(`.collapse[data-bs-parent="${accordionTarget}"]`);
    const accordionEl = accordionCollapseEl.closest('.accordion');
    const accordion = new Collapse(accordionCollapseEl, { toggle: false });

    linkEl.addEventListener('click', () => {
      tab.show();
      accordion.show();
      accordionEl.scrollIntoView();
    });
  });
});
